import { types } from "api";
import { Route, useRouteMatch } from "react-router-dom";
import { routes } from "routes";
import { ViewGroupsPageTable } from "./ViewGroupsPageTable";

export interface ViewGroupsPageItemProps {
	groups: types.Group[];
	updateGroup: (group: types.Group) => void;
	deleteGroup: (group: types.Group) => void;
}

export const ViewGroupsPageItem = ({
	groups,
	updateGroup,
	deleteGroup,
}: ViewGroupsPageItemProps): JSX.Element | null => {
	const routeMatch = useRouteMatch<{ groupId: string }>(
		routes._.groups._.view.path,
	);

	// Find the group
	if (
		routeMatch === null ||
		!routeMatch.params.groupId ||
		groups.length === 0
	) {
		return null;
	}

	let selectedGroup = groups.find(
		(g) => g.groupId === routeMatch.params.groupId,
	);

	if (selectedGroup === undefined) {
		selectedGroup = groups[0]!;
	}

	return (
		<Route>
			<ViewGroupsPageTable
				group={selectedGroup}
				update={updateGroup}
				deleteGroupFromList={deleteGroup}
			/>
		</Route>
	);
};
